import { render } from "./OpportunitySuccess.vue?vue&type=template&id=ede0d00e"
import script from "./OpportunitySuccess.vue?vue&type=script&lang=js"
export * from "./OpportunitySuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__